import { environment } from '@monorepo-channels/shared/util-environments'

export class GoogleMapsLink {
	mapsLink: string
	mapsMobile: string
	mapsDesk: string
	constructor(lat: number, long: number, placeName?: string, address?: string) {
		const latLong = `${long || 0}, ${lat || 0}`
		this.mapsMobile = `https://maps.googleapis.com/maps/api/staticmap?markers=color:red|${latLong}&center=${latLong}&zoom=18&key=${environment.googleMapsAPIToken}&size=343x205`
		this.mapsDesk = `https://maps.googleapis.com/maps/api/staticmap?markers=color:red|${latLong}&center=${latLong}&zoom=18&key=${environment.googleMapsAPIToken}&size=762x446`

		const trimmedName = placeName?.trim()
		const trimmedAddress = address?.trim()

		if (trimmedName && trimmedAddress) {
			this.mapsLink = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
				`${trimmedName}, ${trimmedAddress}`
			)}`
		} else if (trimmedName) {
			this.mapsLink = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
				trimmedName
			)}`
		} else {
			this.mapsLink = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(latLong)}`
		}
	}
}

export class LivemenuLink {
	liveMenuURL: string
	constructor(id: string, alternateMenuId: string | undefined) {
		this.liveMenuURL = alternateMenuId
			? `${environment.liveMenu.url}/${alternateMenuId}?origin=channels`
			: `${environment.liveMenu.url}/${id}?origin=channels`
	}
}
